<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Create User</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">First Name</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.firstname.$model"
                          :class="{'is-invalid': validationStatus($v.firstname)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.firstname.required"
                          class="invalid-feedback"
                        >
                          The name field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Last Name</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.lastname.$model"
                          :class="{'is-invalid': validationStatus($v.lastname)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.lastname.required"
                          class="invalid-feedback"
                        >
                          The name field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Email</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="email"
                          v-model.trim="$v.email.$model"
                          :class="{'is-invalid': validationStatus($v.email)}"
                          class="form-control form-control-lg"
                        />
                        <div v-if="!$v.email.required" class="invalid-feedback">
                          The name field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Password</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="password"
                          v-model.trim="$v.password.$model"
                          :class="{'is-invalid': validationStatus($v.password)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.password.required"
                          class="invalid-feedback"
                        >
                          The name field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Profile Image</label>
                      <div class="col-md-12 border-bottom p-0">
                        <img
                          v-bind:src="previewImage"
                          class="uploading-image"
                        />
                        <input
                          type="file"
                          accept="image/jpeg"
                          @change="uploadImage"
                        />
                        <div v-if="!$v.image.required" class="invalid-feedback">
                          The image field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Country</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          name="country"
                          v-model.trim="$v.country.$model"
                          :class="{'is-invalid': validationStatus($v.country)}"
                          class="form-control"
                        >
                          <option value="">Select Country</option>
                          <option
                            v-for="country in countries"
                            v-bind:key="country.name"
                            v-bind:value="country.id"
                          >
                            {{ country.name }}
                          </option>
                        </select>

                        <div
                          v-if="!$v.country.required"
                          class="invalid-feedback"
                        >
                          The country field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <p>Please select User Role:</p>
                      <b-form-radio-group
                        v-model="selected"
                        :options="options"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-4">
                  <div class="col-sm-12 pl-0 mt-10">
                    <input
                      type="submit"
                      class="btn btn-primary"
                      value="Submit"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>

import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import firebase from "firebase";
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { db } from '../../main'

Vue.use(VueAxios,axios)

export default {
    name: 'Create',
    components:{
        'Header':Header,
        'Sidebar':Sidebar,
        'Footer':Footer,

    },
    data: function() {
        return {
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            ustatus:'',
            image: '',
            country: [],
           // ustatus:null,
            selected:null,
            options: [
            { item: 1, name: 'Admin' },
            { item: 2, name: 'Normal USer' },
            ]
        }
    },
    created: function(){
        this.getCountries();
    },
    validations: {
        firstname: {required},
        lastname: {required},
        email: {required},
        password: {required},
        image: {},
        country: {required},

    },

    methods: {

        addFind: function () {
            this.finds.push({ address: '',city: '' });
          },

        getCountries()
        {
        this.countries = [];

            db.collection("countries")
            .get()
            .then((querySnapshot) => {
                //console.log('hhhh1');
                querySnapshot.forEach((doc) => {
                this.countries.push({
                    id: doc.id,
                    name: doc.data().country,
                    slug: doc.data().slug,
                });
                console.log(doc.id, " => ", doc.data());

                });


            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
        },

        uploadImage(e){
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e =>{
                this.previewImage = e.target.result;
                console.log('dd');
            };
        },

        validationStatus: function(validation) {
            return typeof validation != "undefined" ? validation.$error : false;
        },

        submit: function() {

            this.$v.$touch();
            if (this.$v.$pendding || this.$v.$error) return;

            if( this.selected == null){
                alert("Please select User role");
                return false
            }

            //var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);

            ///////////////////////////////////////////////////////////////////////////////
                        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
            .then(data => {
              const url  = "https://introsbs.com/api/registrationthankyou";

        const data1 = {
						email:this.email,
						name:this.firstname,

	};

              const options = {
				method: 'POST',
				headers: { 'content-type': 'application/json' },
				data: JSON.stringify(data1) ,
				url: url
				};

 axios(options).then(
				(response) => {
  console.warn( Object.keys(response));
  if(response !=""){
                this.$toasted.success('Success, Registration Successfully!', {
                    icon : 'check',
                })
                    //this.$router.push("signin");
  }
 }, () => {
 this.isLoading = false;
 this.$toasted.error('Error,Registration Faild !', {
		icon : 'check',
 //icon : 'error_outline'
 })
 });


                data.user.updateProfile({
                    displayName: this.firstname
                })
                .then(() => {
                var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);

                             db.collection("users")
            .add({
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                image: this.previewImage,
                country: this.country,
                password: this.password,
                created: date,
                modified: date,
				status:this.selected,

            })
            .then((doc) => {
                console.log("Added Successfully!");
                console.log(doc.id);
                console.log(doc.id);
               // db.collection("companies").doc(doc.id).update({ cid: doc.id });

                this.$toasted.success('Success, Added Successfully!', {
                   icon : 'check',
                    //icon : 'error_outline'
                })
                this.$router.push('/users/index');
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
                    var id = localStorage.getItem("userSessionId");
                    console.log('rrr '+id);
                    //this.$router.replace({ name: "Dashboard" });
                    //this.$router.replace({ name: "userProfile" });
                    //this.$router.push('/');

                });
            }).catch(err => {
                console.log('sdd');
                console.log(err.message);

                this.$toasted.error('Error,'+err.message, {
                    //icon : 'check',
                    icon : 'error_outline'
                 })

                this.error = err.message;
            });
            ///////////////////////////////////////////////////////////////////////////////


        }
    }
}
</script>
